<template>
  <div class="v-table-checkbox" ref="input"></div>
</template>

<script>
export default {
  props: {
    value: {
      default() {
        return [];
      }
    },
    selectKey: {
      default: null
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/vue-ext/components/table/checkbox.vue